import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {getURL} from '../../routes';

class Setting extends Component {  
  render() {
    const SettingBtn = ({icon, label, to}) => (
      <div 
        className="setting__btn btn btn-default"
        onClick={() => this.props.dispatch(push(to))}
      >
        <p className="setting__btn__icon">
          <span className={"glyphicon glyphicon-" + icon} />
        </p>
        <p>
          {label}
        </p>
      </div>
    );
    return (
      <div className="setting">
        <SettingBtn 
          icon='home' 
          label="公司管理" 
          to={getURL('/ws-admin/setting/company')}
        />
        <SettingBtn 
          icon='list-alt' 
          label="帳單類別管理" 
          to={getURL('/ws-admin/setting/payment')}
        />
        <SettingBtn 
          icon='usd' 
          label="薪金調整類別管理" 
          to={getURL('/ws-admin/setting/adjustment')}
        />
        <SettingBtn 
          icon='user' 
          label="顧員職位類別管理" 
          to={getURL('/ws-admin/setting/position')}
        />
        <SettingBtn 
          icon='time' 
          label="更次設置" 
          to={getURL('/ws-admin/setting/session')}
        />
        <SettingBtn 
          icon='lock' 
          label="更改密碼" 
          to={getURL('/ws-admin/setting/changepwd')}
        />
      </div>
    )
  }
}

export default connect()(Setting);


// WEBPACK FOOTER //
// ./src/components/Setting/Setting.js